






























































































































import {
  Carousel, Slide, FCButton,
} from '@fc/angie-ui';
import {
  ref, computed, defineComponent, PropType, onMounted,
} from '@vue/composition-api';
import SizeSelectors from '@/shared/components/SizeSelectors.vue';
import productIndex from '@/shared/datasets/products';
import FCImage from '~/components/FCImage.vue';
import AffirmInline from '~/components/AffirmInline.vue';
import SplitView from '~/components/SplitView.vue';
import Video from '~/components/storyblok/Video/Video.vue';
import ProductsIncludedItems from '~/components/products/Products_IncludedItems.vue';
import { getIncludedItems } from '~/utils/accessoryBundleProducts';
import AccessoryVideoHighlight from '~/components/accessories/AccessoryVideoHighlight.vue';
import { useCartContext } from '~/composables/useCartContext';
import { transformShopifyProdId } from '~/selectors/selectors';
import { IAccessoryBundleProductsProps, Media } from './types';

export default defineComponent({
  name: 'AccessoryBundleProducts',
  inheritAttrs: false,
  components: {
    Carousel,
    Slide,
    FCImage,
    Video,
    SplitView,
    AffirmInline,
    ProductsIncludedItems,
    SizeSelectors,
    FCButton,
    AccessoryVideoHighlight,
  },
  props: {
    productName: {
      type: String,
      required: true,
    },
    mediaGrid: {
      type: Array as PropType<Media[]>,
      required: true,
    },
    titleOverride: {
      type: String,
      required: false,
      default: '',
    },
    descriptionOverride: {
      type: String,
      required: false,
      default: '',
    },
    isSoldOut: {
      type: Boolean,
      default: false,
    },
    includes: {
      type: Array as PropType<string[]>,
      required: false,
      default: () => [],
    },
    testShopifyId: {
      type: String,
      required: true,
    },
    prodShopifyId: {
      type: String,
      required: true,
    },
  },
  setup(props: IAccessoryBundleProductsProps) {
    // @ts-ignore
    const { $store, $ecommAnalytics } = useNuxtApp();

    const prod = computed(() => transformShopifyProdId({
      testShopifyId: props.testShopifyId as string, prodShopifyId: props.prodShopifyId as string, oldId: props.productName as string, store: $store,
    }) ?? {
      title: '',
      description: '',
      price: '',
      oldPrice: '',
      sold_out: false,
      text: '',
      variants: [],
      selects: [],
    });

    const includedItems = computed(() => {
      if (props.productName === 'fightcamp_family_bundle') {
        return [
          productIndex.kidsglovesv2, productIndex.kidsglovesv2, productIndex.glovesv2, productIndex.glovesv2,
        ];
      }
      return getIncludedItems(props.includes);
    });

    const priceNumber = computed(() => (parseInt(prod.value.price, 10)));
    const priceGreaterThanFifty = computed(() => ((parseInt(prod.value.price, 10) > 5000)));

    const selects = computed(() => prod.value?.selects ?? prod.value?.select ?? null);

    const sizeSelected = ref<null|string>(null);
    const sizeSelectorError = ref(false);
    const updateSizeValue = (value: string) => {
      sizeSelected.value = value;
    };

    function handleSizeItem() {
      if (sizeSelected.value) {
        sizeSelectorError.value = false;
        addToCart(sizeSelected.value);
      } else {
        sizeSelectorError.value = true;
      }
    }

    function triggerAddToCart() {
      const optionsLength = selects.value?.options?.length ?? 0;

      if (optionsLength > 0) {
        handleSizeItem();
      } else {
        const finalId = prod.value?.variants[0]?.id;
        addToCart(finalId);
      }
    }

    const { insertItemToCart } = useCartContext();

    async function addToCart(itemId: string) {
      await insertItemToCart(itemId);

      $store.commit('ITEM_ADDED');
      $store.dispatch('toggleDrawer');
    }

    function isImage(media: {Image: object}) { return !!media?.Image; }
    const soldOut = computed(() => props.isSoldOut || prod?.value?.sold_out);

    const getTheme = computed(() => (soldOut.value ? 'button-disabled' : 'button-primary'));
    const getCopy = computed(() => (soldOut.value ? 'Sold Out' : 'Add to Cart'));

    onMounted(() => {
      const shopifyProduct = $store.getters.productsCollection?.find(p => p.id === prod.value.id);
      $ecommAnalytics.view_item([
        {
          item_id: shopifyProduct.id,
          item_name: shopifyProduct.title,
          price: shopifyProduct.variants[0].price,
          item_category: shopifyProduct.productType,

        },
      ]);
    });

    return {
      prod,
      isImage,
      addToCart,
      updateSizeValue,
      triggerAddToCart,
      sizeSelectorError,
      includedItems,
      selects,
      toggleHideNavigation: computed(() => props.mediaGrid.length <= 1),
      getTheme,
      getCopy,
      priceNumber,
      priceGreaterThanFifty,
    };
  },
});
